export const usersAdmin = state =>
  state.users ? state.users.filter(u => u.admin === true) : null;
export const usersTech = state =>
  state.users ? state.users.filter(u => u.admin === false) : null;
export const usersLoadInProgress = state => state.users === null;

export const user = state => state.editedUser;
export const isUserLoading = state => state.editedUser === null;



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/selectors/users.js